// eslint-disable-next-line import/no-relative-packages
import config_data from '../../../../../brand.config.json';

type TBrandEmbedConfig = {
    allowed_parent_domains?: string[];
    allow_localhost?: boolean;
};

const normalizeHostname = (value: string): string =>
    value
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/\/.*$/, '');

export const getAllowedEmbedParentDomains = (): string[] => {
    const embed = (config_data as { embed?: TBrandEmbedConfig }).embed;
    const domains = embed?.allowed_parent_domains;

    if (!Array.isArray(domains) || domains.length === 0) {
        return [];
    }

    return domains.map(normalizeHostname).filter(Boolean);
};

export const isLocalhostHostname = (hostname: string): boolean =>
    /^localhost$/i.test(hostname) || hostname === '127.0.0.1' || hostname === '[::1]';

export const isAllowedEmbedParentHostname = (hostname: string): boolean => {
    if (!hostname) return false;

    const normalized = normalizeHostname(hostname);
    const embed = (config_data as { embed?: TBrandEmbedConfig }).embed;

    if (embed?.allow_localhost !== false && isLocalhostHostname(normalized)) {
        return true;
    }

    const allowed = getAllowedEmbedParentDomains();
    if (!allowed.length) return true;

    return allowed.some(
        allowedHost =>
            normalized === allowedHost ||
            normalized === allowedHost.replace(/^www\./, '') ||
            allowedHost === normalized.replace(/^www\./, '')
    );
};

export const isAllowedEmbedParentOrigin = (origin: string): boolean => {
    if (!origin) return false;

    try {
        return isAllowedEmbedParentHostname(new URL(origin).hostname);
    } catch {
        return isAllowedEmbedParentHostname(origin);
    }
};
